export enum BannerName {
  ClubHubHomepage = 'ch-homepage-banner',

  IgniteHomepage = 'ignite-homepage-banner',
  IgniteLandingProduct = 'ignite-landing-product-banner',
  IgniteLandingAffordability = 'ignite-landing-affordability-banner',
  IgniteLandingCriteria = 'ignite-landing-criteria-banner',
  IgniteLandingProperty = 'ignite-landing-property-banner',

  ResiAffordabilityLeft = 'resi-affordability-left',
  ResiAffordabilityRight = 'resi-affordability-right',
  ResiAffordabilityLoading = 'resi-loading-affordability',
  ResiAffordabilityResults = 'resi-results-affordability',
  ResiCriteriaLeft = 'resi-criteria-left',
  ResiCriteriaRight = 'resi-criteria-right',
  ResiCriteriaLoading = 'resi-loading-criteria',
  ResiCriteriaResults = 'resi-results-criteria',
  ResiProductLeft = 'resi-product-left',
  ResiProductRight = 'resi-product-right',
  ResiProductLoading = 'resi-loading-product',
  ResiProductResults = 'resi-results-product',
  ResiPropertyLeft = 'resi-property-left',
  ResiPropertyRight = 'resi-property-right',
  ResiPropertyLoading = 'resi-loading-property',
  ResiPropertyResults = 'resi-results-property',

  BtlAffordabilityLeft = 'btl-affordability-left',
  BtlAffordabilityRight = 'btl-affordability-right',
  BtlAffordabilityLoading = 'btl-loading-affordability',
  BtlAffordabilityResults = 'btl-results-affordability',
  BtlCriteriaLeft = 'btl-criteria-left',
  BtlCriteriaRight = 'btl-criteria-right',
  BtlCriteriaLoading = 'btl-loading-criteria',
  BtlCriteriaResults = 'btl-results-criteria',
  BtlProductLeft = 'btl-product-left',
  BtlProductRight = 'btl-product-right',
  BtlProductLoading = 'btl-loading-product',
  BtlProductResults = 'btl-results-product',
  BtlPropertyLeft = 'btl-property-left',
  BtlPropertyLoading = 'btl-loading-property',
  BtlPropertyResults = 'btl-results-property',
  BtlPropertyRight = 'btl-property-right',

  LaterLifeCriteriaLeft = 'laterlife-criteria-left',
  LaterLifeCriteriaRight = 'laterlife-criteria-right',
  LaterLifeCriteriaLoading = 'laterlife-loading-criteria',
  LaterLifeCriteriaResults = 'laterlife-results-criteria',

  SecondChargeCriteriaLeft = 'secondcharge-criteria-left',
  SecondChargeCriteriaRight = 'secondcharge-criteria-right',
  SecondChargeCriteriaLoading = 'secondcharge-loading-criteria',
  SecondChargeCriteriaResults = 'secondcharge-results-criteria',

  BridgingCriteriaLeft = 'bridging-criteria-left',
  BridgingCriteriaRight = 'bridging-criteria-right',
  BridgingCriteriaLoading = 'bridging-loading-criteria',
  BridgingCriteriaResults = 'bridging-results-criteria',

  ProcFeeClaimLeft = 'proc-claim-left',
  ProcFeeClaimRight = 'proc-claim-right',
}

export interface Banner {
  name: string;
  imageUrl: string;
  link: string;
}
